import { mapGetters } from 'vuex';
import AuthMixin from '@/mixins/Auth';
import AlertError from '@/components/Alerts/AlertError/AlertError.vue';

export default {
    name: 'DialogRemoveNetwork',

    components: {
        AlertError,
    },

    props: {
        isOpen: {
            type: Boolean,
            required: true,
            default: false
        },
    },

    mixins: [
        AuthMixin,
    ],

    data() {
        return this.initialState();
    },

    computed: {
        ...mapGetters({
            error: 'networks/error',
            humanError: 'networks/humanError',
            selectedNetwork: 'networks/selectedNetwork',
        }),
    },

    watch: {
        // when re opened,  populate field
        isOpen: function (newVal, oldVal) {
            if (newVal === true) {
                this.populateFields();
            }
        },
        selectedNetwork: function (newVal, oldVal){
            if (newVal != oldVal) {
                this.populateFields();
            }
        }
    },
    
    methods: {
        initialState() {
            return {
                submitting: false,
                form: {
                    id: null,
                    name: null,
                },
            };
        },

        populateFields() {
            if (this.selectedNetwork) {
                this.form.id = this.selectedNetwork.id;
                this.form.name = this.selectedNetwork.name;
            }
        },

        async submit() {
            if (!this.$refs.formRemoveNetwork.validate()) {
                return false;
            }

            let payload = {
                id: this.form.id,
            }

            // Toggle submit button
            this.toggleSubmitting();

            let result = await this.$store.dispatch('networks/remove', payload);

            // // Re-enable button
            this.toggleSubmitting();

            // On success
            if (result === true) {
                // Show success snackbar
                this.$store.dispatch('UI/showSnackbar', {
                    message: 'Network removida com sucesso.',
                    color: 'success'
                });

                // set promiseNetworks to NULL in order to be possible to make new API Request
                this.$store.commit('networks/setPromiseNetworks', null);

                // refresh Table Networks
                this.$store.dispatch('networks/get', payload);

                // closes dialog
                this.closeDialog();
            }
        },

        /**
         * Used to disable Submit button
         */
        toggleSubmitting() {
            this.submitting = !this.submitting;
        },

        closeDialog() {
            this.$emit("close-dialog");
            this.resetForm();
        },

        resetForm() {
            Object.assign(this.$data, this.initialState());
            this.$refs.formRemoveNetwork.reset();
        }
    },
};
